// extracted by mini-css-extract-plugin
export default {"root":"Header-root_ILLmJ","container":"Header-container_Cd_CX","controls":"Header-controls_eJLuK","widgets":"Header-widgets_MF8cq"};